import React, { useState } from "react";
import {
  alpha,
  Box,
  Menu,
  MenuProps,
  styled,
  Typography,
} from "@mui/material";
import { LineMdChevronDown } from "../../assets/Icons/LineMdChevronDown";
import { Link } from "react-router-dom"; // For routing purposes (optional)
import { ReactNode } from "react";
import { customValue } from "../../../utils/colorVariable";

interface MenuLinkProps {
  label: string;
  link: string;
  icon?: ReactNode;
  isActive?: boolean;
  underline?: "none" | "underline";
  color?: string;
  bgColor?: string;
  display?: string;
  alignItems?: string;
  justifyContent?: string;
  hasDropdown?: boolean;
  children?: ReactNode; // for nested dropdown items
}

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: customValue.borderRadius,
    marginTop: theme.spacing(0),
    minWidth: 130,
    color: "rgb(55, 65, 81)",
    paddingBottom: 20,
    backgroundColor: alpha(theme.palette.common.white, 0.9),
  },
}));

const MenuLink = ({
  label,
  link,
  icon,
  isActive = false,
  underline = "none",
  color = "#000",
  bgColor = "#f0f0f0",
  display = "flex",
  alignItems = "center",
  justifyContent = "center",
  hasDropdown = false,
  children,
}: MenuLinkProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const isMenuOpen = Boolean(anchorEl);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <Link
        to={link}
        style={{ textDecoration: underline === "none" ? "none" : "underline" }}
      >
        <Box
          display={display}
          alignItems={alignItems}
          justifyContent={justifyContent}
          sx={{
            backgroundColor: isActive ? bgColor : "transparent",
            color: color,
            padding: "8px 10px",
            borderRadius: customValue.borderRadius,
            margin: 0,
            "&:hover": {
              backgroundColor: isActive ? bgColor : "#f0f0f0",
            },
          }}
          onClick={hasDropdown ? handleMenuOpen : undefined}
        >
          {icon && <Box mr={1}>{icon}</Box>}
          <Typography
            variant="body1"
            sx={{ fontWeight: isActive ? "bold" : "normal" }}
          >
            {label}
          </Typography>
          {hasDropdown && (
            <LineMdChevronDown
              style={{
                transform: isMenuOpen ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.3s ease",
                marginLeft: "8px",
              }}
              width="20"
              height="20"
            />
          )}
        </Box>
      </Link>
      {hasDropdown && children && (
        <StyledMenu
          anchorEl={anchorEl}
          open={isMenuOpen}
          onClose={handleMenuClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          {children}
        </StyledMenu>
      )}
    </Box>
  );
};

export default MenuLink;
